import { enableProdMode, importProvidersFrom } from '@angular/core';


import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ErrorStateMatcher, ShowOnDirtyErrorStateMatcher } from '@angular/material/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AdminGuard, ConversationsRedirectGuard, EnrolmentRedirectGuard, FormSubmissionsGuard, LoggedInGuard, LoggedOutGuard, OrganizationGuard, PermissionGuard, SystemGuard } from '@app/common/guards';
import { FsProgressModule } from '@firestitch/progress';
import { SideNavModule } from '@libs/layouts/side-nav';
import { AppRoutingModule } from './app/app-routing.module';
import { AppComponent } from './app/app.component';
import { CoreModule } from './app/core/core.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(AppRoutingModule, CoreModule, SideNavModule, FsProgressModule),
    LoggedInGuard,
    LoggedOutGuard,
    AdminGuard,
    SystemGuard,
    OrganizationGuard,
    EnrolmentRedirectGuard,
    FormSubmissionsGuard,
    PermissionGuard,
    ConversationsRedirectGuard,
    {
      provide: ErrorStateMatcher,
      useClass: ShowOnDirtyErrorStateMatcher,
    },
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations()
  ]
});
